export class EndDeviceAssignmentModel {
    sensorAssignmentId: string;
    deviceName: string;
    deviceId: string;
}

export class EndDeviceAssignment {
    selection: string[];
    endDateTime: string;
}